import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const logsApi = {
    getLogs: async (token, page=1, limit=20, search='') => {
        const response = await apiFetch(`${BASE_URL}/logs?page=${page}&limit=${limit}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    },

    getLogsById: async (token, id, page=1, limit=20, search='') => {
        const response = await apiFetch(`${BASE_URL}/logs/${id}?page=${page}&limit=${limit}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
        });
        const data = await response.json();
        return { status: response.status, data };
    },
}